import React from 'react';
import {Group} from '../../graphql';
import {GroupEditView, GroupEditViewProps} from './view';

interface GroupEditContainerProps extends GroupEditViewProps {
}

export const GroupEditContainer = (props: GroupEditContainerProps) => {
  return <GroupEditView {...props} />;
};
